export const DEFAULT_GROWTH_RANGE = 1.55;


// WEBPACK FOOTER //
// ./src/constants/child.js